import React from 'react';

import Link from '@dashboard/components/mui-atoms/Link';
import { FDomainNameVerificationFragment } from '@dashboard/generated/wp/platform';
import useCurrentPlatformId from '@dashboard/hooks/route/useCurrentPlatformId';
import { TableCell, TableRow, Typography } from '@mui/material';

import { renderDomainNameApprovalStatus, renderDomainNameVerificationStatus } from './Status';

type Props = {
  model: FDomainNameVerificationFragment;
};

export default function DomainNameRow({ model }: Props) {
  const platformId = useCurrentPlatformId();
  return (
    <TableRow>
      <TableCell>
        <Link href={`/o/${platformId}/domain-names/${model.id}`}>
          <Typography component="span" fontWeight="medium">
            {model.domainName}
          </Typography>
        </Link>
      </TableCell>
      <TableCell>{renderDomainNameVerificationStatus(model.status)}</TableCell>
      <TableCell>{renderDomainNameApprovalStatus(model.approvalStatus)}</TableCell>
    </TableRow>
  );
}
